<scaffold-dialog [title]="data.title" size="half">
  <div scaffoldDialogBody>
    <nb-form-field>
      <input nbInput [(ngModel)]="searchParam" placeholder="Search Components" fullWidth />
      <nb-icon status="primary" nbSuffix pack="fas" icon="search"></nb-icon>
    </nb-form-field>
    <nb-accordion multi="true">
      <nb-accordion-item *ngFor="let cat of cats" expanded [style.display]="filter(catagories[cat]).length > 0 ? 'block':'none'">
        <nb-accordion-item-header>{{cat}}</nb-accordion-item-header>
        <nb-accordion-item-body>
          <div class="row">
            <nb-list>
              <nb-list-item *ngFor="let item of filter(catagories[cat])" (click)="dialogRef.close(cloneDeep(item))" (keydown.enter)="dialogRef.close(cloneDeep(item))" tabindex="0" role="button">
                <div class="col-sm-3 compnent-list-item-label">
                  <nb-icon pack='fas' [icon]="settings[item.type].icon||'file'"></nb-icon>
                  <div>{{settings[item.type].Name}}</div>
                </div>
                <div class="col-sm-9">
                  <p>{{settings[item.type].description}}</p>
                </div>
              </nb-list-item>
            </nb-list>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item *ngIf="premade.length > 0" expanded>
        <nb-accordion-item-header>Pre-Configured Components</nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list>
            <nb-list-item *ngFor="let item of premade" (click)="dialogRef.close(cloneDeep(item))" (keydown.enter)="dialogRef.close(cloneDeep(item))" tabindex="0" role="button">
              <div class="col-sm-3 compnent-list-item-label">
                <nb-icon pack='fas' [icon]="settings[item.type].icon||'file'"></nb-icon>
                <div>{{settings[item.type].Name}}</div>
              </div>
              <div class="col-sm-8">
                <p>Configured for {{item.name}}</p>
                <p>{{settings[item.type].description}}</p>
              </div>
            </nb-list-item>
          </nb-list>          
        </nb-accordion-item-body>
      </nb-accordion-item>

    </nb-accordion>
  </div>
</scaffold-dialog>
